// src/components/modal/realtime/usePedidoStatus.js
import { useEffect, useState } from "react";
import axios from "axios";
import authService from "@/services/authService";

// API Configuration
const API_CONFIG = {
  BACKEND_URL:
    process.env.REACT_APP_BACKEND_URL ||
    "https://delivery-bonfimgourmet-244425130782.southamerica-east1.run.app",
  POLLING_INTERVAL: 10000, // 10 seconds
};

export function usePedidoStatus() {
  const [pedido, setPedido] = useState(0);

  useEffect(() => {
    // Get JWT token
    const token = authService.getToken();
    if (!token) {
      console.warn("⚠️ No JWT token found - polling disabled");
      return;
    }

    /**
     * Fetch orders with status "Aguardando"
     */
    const fetchPendingOrders = async () => {
      try {
        const response = await axios.get(`${API_CONFIG.BACKEND_URL}/orders`, {
          params: { status: "Aguardando" },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const orders = response.data?.data || response.data || [];
        const count = Array.isArray(orders) ? orders.length : 0;
        setPedido(count);
      } catch (error) {
        console.error("❌ Error fetching pending orders:", error);
        // Keep previous count on error
      }
    };

    // Initial fetch
    fetchPendingOrders();

    // Set up polling interval
    const intervalId = setInterval(
      fetchPendingOrders,
      API_CONFIG.POLLING_INTERVAL
    );

    // Cleanup
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return { pedido };
}
